import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { showErrorNotification } from 'shared/helpers/showErrorNotification';
import { useCountdown } from 'shared/helpers/useCountdown';
import { sendRestorePasswordEmail } from 'entities/Auth/api';
import { useForgotPasswordStore } from 'widgets/auth/forgotPassword/_MainModal/model/state';
import { StatusModal } from 'widgets/auth/_common/ui/StatusModal';

export const FPEmailSentModal: FunctionComponent = () => {
	const { t } = useTranslation();
	const { emailToSend } = useForgotPasswordStore();
	const [timeLeft, setCountdown] = useCountdown('/forgot-password/email-sent');

	const handleSendRestorePasswordEmail = () => {
		sendRestorePasswordEmail({ email: emailToSend })
			.then((res) => {
				if (res?.data?.success) {
					setCountdown(120);
				}
			})
			.catch((err) => {
				showErrorNotification(err);
			});
	};

	return (
		<StatusModal
			type={'info'}
			title={t('auth.status_modal.email_sent')}
			message={t('auth.status_modal.password_email_message')}
			icon={'message_open'}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
				<Typography variant={'body2'} color={ColorPalette.astronaut}>
					{t('auth.status_modal.password_dont_receive_restore_email')}
				</Typography>
				{timeLeft ? (
					<Typography variant={'body2'} color={ColorPalette.royalBlue} sx={{ marginLeft: '8px' }}>
						{timeLeft.minutes}:{timeLeft.seconds}
					</Typography>
				) : (
					<Typography
						variant={'body2'}
						color={ColorPalette.royalBlue}
						sx={{ cursor: 'pointer', marginLeft: '8px' }}
						onClick={handleSendRestorePasswordEmail}
					>
						{t('auth.status_modal.resend')}
					</Typography>
				)}
			</Box>
		</StatusModal>
	);
};
